import { Box, Flex, HStack, Image } from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import DashboardHeader from "../../../components/common/DashboardHeader";
import PaymentAmount from "../../../components/trainee/payments/PaymentAmount";
import VerifyPayment from "../../../components/trainee/payments/VerifyPayment";
import RegisterLine from "../../../components/trainee/register/RegisterLine";
import rarrow from '../../../img/rarrow.svg';


const Payment = () => {

    const [pageState, setPagestate] = useState(0);
    const pages = [
        { index: 1, component: PaymentAmount },
        { index: 2, component: VerifyPayment },

    ]

    const switchPage = () => {

        const Component = pages[pageState].component;
        

        return <Component nextPage={nextPage} prePage={prePage} />

    }


    const nextPage: any = () => {
        if (pageState < pages.length) {
            const pg = pageState
            setPagestate(pg+1)
        }
        localStorage.setItem("page_payment_no", pageState.toString());
    }

    const prePage = () => {
        if (pageState > 0) {
            const pg = pageState
            setPagestate(pg-1)
        }
        localStorage.setItem("page_payment_no", pageState.toString());
    }

    useEffect(() => {
        const pageNo = localStorage.getItem("page_payment_no") ?? '0'

        setPagestate(parseInt(pageNo));
    }, []);

    const clearCourseFromLocalStorage = () => {

        window.location.reload();
    }

    return (
        <>
            <DashboardHeader />

            <Flex justifyContent="center" bg='#F9F8F8' height='100%' bgSize='cover'>
                <Box mt='50px'  width={["95%","95%","80%",'60%']} mx='auto'>
                    <Box pt='50px'  bg='white' boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)" px={8} >

                        <Flex  justifyContent='center'>
                            <HStack spacing={["2px","2px","4px","8px"]} >
                                <RegisterLine fontWeight={pageState === 0 ? "700" : "400"} position="1" title="Payment Amount" bgColor={pageState === 0 ? "brand.2" : "brand.1"} textColor={pageState === 0 ? "#EC3337" : "#616161"} />


                                <Image src={rarrow} />


                                <RegisterLine fontWeight={pageState === 1 ? "700" : "400"} position="2" title="Verify Payment" bgColor={pageState === 1 ? "brand.2" : "brand.1"} textColor={pageState === 1 ? "#EC3337" : "#616161"} />


                            </HStack>
                        </Flex>

                    </Box>
                    <Box boxShadow="base" bg="white" mb='50px' py={4} px={["0px","0px","4px","8px"]} >

                        {
                            switchPage()
                        }


                      
                    </Box>

                </Box>
            </Flex>






        </>
    );
}

export default Payment;